import { http } from '../http';

export class ShareableLinkAPI {

    static get instance() {
        return this.INSTANCE;
    }

    private static INSTANCE = new ShareableLinkAPI();

    private namespace: string = 'api/admin/v1';

    public linkVerification(token: string, params: any) {
        const endpoint = `${this.namespace}/shareable/link/verification`;
        const headers = http.getTokenHeaders(token);
        return http.post(endpoint, headers, params).then((response) => {
            return true;
        }).catch(() => {
            return false;
        });
    }

}

export const shareableLinkAPI = new ShareableLinkAPI();

